import * as React from "react";

import "./loading-panel.scss";

import {cs} from "@Common/react/chain-services";

export const LoadingPanel = ({}) => cs(
    () => (
        <div className="loading-panel-33q">
            <i className="fa fa-spinner fa-pulse" xd-qa-type="icon" xd-qa-name="Loading"/>
        </div>
    ),
);
